import {
  IconBell,
  IconChartHistogram,
  IconTargetArrow,
  IconBug,
  IconLogout,
  IconMenu2,
} from "@tabler/icons-react";
import logo from "../assets/logo.svg";
import {
  DropdownDivider,
  NavDropdown,
  NavLink,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/authReducer";
import { API_ENDPOINTS } from "../constant/_constant";
import { useEffect } from "react";
import usePostRequest from "../hooks/usePostRequest";
import Navbar from "../layout/Navbar";
import { usePostHog } from "@posthog/react";
import * as Sentry from "@sentry/react";
import "./Header.css";

const topHeaderIcons = [
  { id: 1, icon: <IconBell />, text: "Notifications" },
  { id: 2, icon: <IconChartHistogram />, text: "My Metrics" },
  { id: 3, icon: <IconTargetArrow />, text: "Revenue Goals" },
  // { id: 4, icon: <IconBug />, text: "Bugs" },
];

const Header = () => {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const posthog = usePostHog();
  // check perminssion
  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);

  const location = useLocation();

  const userPermissions = user?.permissions?.manage_users || [];
  const settingPermissions = user?.permissions?.manage_setting || [];
  const rolePermissions = user?.permissions?.manage_role || [];

  const canReadUser = hasPermission(userPermissions, "read");
  const canReadSetting = hasPermission(settingPermissions, "read");
  const canReadRole = hasPermission(rolePermissions, "read");

  const { postData: CheckAuth } = usePostRequest(API_ENDPOINTS.CHECK_TOKEN);

  const { postData: GetQuickBookVendor, data: QuickbookVendors } =
    usePostRequest(API_ENDPOINTS.SEARCH_QUICKBOOK_VENDOR);

  const token = localStorage.getItem("token");

  const onSuccess = (response) => {
    //console.log("succes")
  };

  // useEffect(() => {
  //   GetQuickBookVendor({ module_type: "ORDER" });
  // }, []);

  useEffect(() => {
    if (QuickbookVendors) {
      localStorage.setItem(
        "quickbookVendors",
        JSON.stringify(QuickbookVendors),
      );
    }
  }, [QuickbookVendors]);

  const onError = (error) => {
    dispatch(logout());
    navigate("/");
  };

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  useEffect(() => {
    CheckAuth({ token }, onSuccess, onError);
  }, [location]);

  const handleItemClick = (path) => {
    navigate(path);
    if (path === "/login") {
      dispatch(logout());
      posthog.reset();
      Sentry.setUser(null);
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="sticky-header">
      <div className="navbar navbar-expand-md d-print-none topheader_bg">
        <div className="container-xl position-relative">
          <div className="toggle-navbar" onClick={toggleNavbar}>
            <IconMenu2 />
          </div>
          <div className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
            <img src={logo} alt="logo" />
          </div>

          <div className="d-md-flex gap-2 align-items-center">
            <div className="nav-item dropdown d-none d-md-flex me-3 gap-3">
              {/* {topHeaderIcons.map((icon) => (
                <OverlayTrigger
                  key={icon?.id}
                  placement="bottom"
                  overlay={<Tooltip id="tooltip-top">{icon?.text}</Tooltip>}
                >
                  <NavLink to="#" className="mini_icon">
                    {icon?.icon}
                    {icon.text === "Notifications" && (
                      <span className="badge bg-orange text-orange-fg  badge-pill">
                        {0}
                      </span>
                    )}
                  </NavLink>
                </OverlayTrigger>
              ))} */}
              {/* <NavDropdown
                title={<IconBug />}
                id="navbarScrollingDropdown"
                className="no-arrow"
              >
                <NavDropdown.Item
                  className="d-none d-sm-block"
                  as={NavLink}
                  to={"/report-bug"}
                  onClick={() => handleItemClick("/report-bug")}
                >
                  Report a bug
                </NavDropdown.Item>
                <NavDropdown.Item
                  className="d-none d-sm-block"
                  as={NavLink}
                  to={"/report-bug"}
                  onClick={() => handleItemClick("/list-bugs")}
                >
                  Bugs
                </NavDropdown.Item>
              </NavDropdown> */}
            </div>

            <NavDropdown
              title={
                <div className=" d-flex lh-1 text-reset p-0 align-items-center">
                  {/* <Image
                  src={userweb}
                  roundedCircle
                  width="35px"
                  height="35px"
                  className="avatar avatar-sm"
                /> */}
                  <span className="avatar avatar-sm rounded-circle">
                    {user?.abbreviation}
                  </span>
                  <div className="d-none d-xl-block ps-2">
                    <div>{`${user?.first_name} ${user?.last_name}`}</div>
                    <div className="mt-1 small text-secondary text-capitalize">
                      {user?.roles?.map((role, idx) => (
                        <span key={role}>
                          {`${
                            idx < user?.roles?.length - 1
                              ? `${role}, `
                              : `${role}`
                          }`}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              }
              id="navbarScrollingDropdown"
              className="no-arrow"
            >
              <NavDropdown.Item
                className="d-none d-sm-block"
                as={NavLink}
                to={"#"}
                // onClick={() => handleItemClick("/profile")}
              >
                My Profile
              </NavDropdown.Item>

              {canReadRole && (
                <NavDropdown.Item
                  className="d-none d-sm-block"
                  as={NavLink}
                  to={"#"}
                  onClick={() => handleItemClick("/departments")}
                >
                  Departments
                </NavDropdown.Item>
              )}

              {canReadUser && (
                <NavDropdown.Item
                  className="d-none d-sm-block"
                  as={NavLink}
                  to={"#"}
                  onClick={() => handleItemClick("/users")}
                >
                  Users
                </NavDropdown.Item>
              )}

              {/* {canReadSetting && (
                <NavDropdown.Item
                  className="d-none d-sm-block"
                  as={NavLink}
                  to={"/contract-type"}
                  onClick={() => handleItemClick("/contract-type")}
                >
                  Settings
                </NavDropdown.Item>
              )} */}

              <DropdownDivider className="d-none d-sm-block mb-0" />
              <NavDropdown.Item
                className="justify-content-between text-danger"
                as={NavLink}
                to={"#"}
                onClick={() => handleItemClick("/login")}
              >
                Logout <IconLogout />
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </div>
      <div className="navbar-component">
        <Navbar isOpen={isOpen} />
      </div>
    </header>
  );
};

export default Header;
